/**
 * System-wide chart tooltip dismiss.
 *
 * D3 tooltips are position:fixed and only hide on per-mark mouseleave, which
 * often misses (scroll, fast exits, redraw). One document-level listener closes
 * any open .d3-tooltip / .chart-tooltip when the pointer leaves its chart
 * container, on scroll, or on window blur.
 */

const TIP_SELECTOR = '.d3-tooltip, .chart-tooltip';

let installed = false;

function hideTip(tip) {
  if (tip) tip.style.opacity = '0';
}

function hideAllTooltips() {
  document.querySelectorAll(TIP_SELECTOR).forEach(hideTip);
}

function hideOutsidePointer(event) {
  document.querySelectorAll(TIP_SELECTOR).forEach((tip) => {
    if (tip.style.opacity === '0' || tip.style.opacity === '') return;
    const container = tip.closest('.chart-container');
    if (!container || !container.contains(event.target)) hideTip(tip);
  });
}

/** Install once for the app lifetime. Safe to call repeatedly. */
export function ensureChartTooltipDismiss() {
  if (installed || typeof document === 'undefined') return;
  installed = true;

  // pointerover bubbles from the new target — catches leaving a chart for another
  // element without relying on that chart's SVG hit targets.
  document.addEventListener('pointerover', hideOutsidePointer, true);
  window.addEventListener('scroll', hideAllTooltips, true);
  window.addEventListener('blur', hideAllTooltips);
}

/** Hide a single tooltip element (ref.current or DOM node). */
export function hideChartTooltip(el) {
  hideTip(el);
}
